import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PopoverArrowDirective } from './popover-arrow.directive';
import { PopoverCloseDirective } from './popover-close.directive';
import { PopoverDirective } from './popover.directive';
import { PopoverComponent } from './popover/popover.component';
import { PopoverTemplateComponent } from './template/template.component';

@NgModule({
    declarations: [PopoverComponent, PopoverCloseDirective, PopoverArrowDirective, PopoverDirective, PopoverTemplateComponent],
    imports: [
        CommonModule,
        OverlayModule,
        PortalModule
    ],
    exports: [
        PopoverCloseDirective,
        PopoverDirective,
        PopoverTemplateComponent,
        A11yModule
    ]
})
export class PopoverModule { }
